module.exports = __webpack_public_path__ + "static/media/5DPO15.ff009846.jpg";